import React, { Fragment } from "react";

import img13 from "../../../images/service/token Development/1.png";
import img14 from "../../../images/service/token Development/2.png";


import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import Benefit from "../../../components/PageSection/BenefitSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";

// --------------------------------------------------
// DATA
// --------------------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "Custom Token Development",
    content:
      "Design and development of secure, scalable, and utility-driven cryptocurrency tokens tailored to your business goals.",
  },
  {
    icon: sIcon2,
    title: "Token Standards Implementation",
    content:
      "Creation of ERC-20, BEP-20, ERC-721, ERC-1155, and other token standards with full compliance.",
  },
  {
    icon: sIcon3,
    title: "Token Smart Contracts",
    content:
      "Gas-optimized smart contracts with minting, burning, vesting, and governance logic.",
  },
];

const benefits = [
  {
    title: "Business Tokenization",
    description:
      "Transform assets, services, or ecosystems into tradable digital tokens.",
    icon: sIcon1,
  },
  {
    title: "Global Fundraising",
    description:
      "Raise capital and onboard users globally without intermediaries.",
    icon: sIcon2,
  },
  {
    title: "Decentralized Control",
    description:
      "Enable trustless ownership, governance, and automation via smart contracts.",
    icon: sIcon3,
  },
  {
    title: "Liquidity & Market Access",
    description:
      "Tokens can be listed on exchanges, enabling liquidity and price discovery.",
    icon: sIcon4,
  },
  {
    title: "High Transparency",
    description:
      "Immutable blockchain records build investor and user confidence.",
    icon: sIcon5,
  },
  {
    title: "Cross-Industry Adoption",
    description:
      "Applicable across DeFi, gaming, NFTs, supply chain, fintech, and more.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is cryptocurrency token development?",
    a: "It is the process of creating blockchain-based digital tokens with specific utilities, supply models, and governance rules.",
  },
  {
    q: "Which blockchains do you support?",
    a: "Ethereum, Binance Smart Chain, Polygon, Solana, Avalanche, and other EVM-compatible networks.",
  },
  {
    q: "Can I create my own token without coding knowledge?",
    a: "Yes. We handle the complete technical development while you focus on business and strategy.",
  },
  {
    q: "Do you provide token audits?",
    a: "Yes. All smart contracts undergo rigorous testing and security audits.",
  },
];

// --------------------------------------------------
// PAGE COMPONENT
// --------------------------------------------------

export default function CryptocurrencyTokenDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Cryptocurrency Token Development"
        pagesub="Create, launch, and scale your own digital token ecosystem"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Build & Launch Your Own{" "}
            <span className="gradient-text">Cryptocurrency Token</span>
          </>
        }
        subtitle={`We help startups, enterprises, and Web3 innovators design, develop,
and deploy secure cryptocurrency tokens across leading blockchain networks.
From concept to launch, we deliver future-ready token solutions.`}
        buttonText="Create Your Token"
        buttonLink="/contact"
        image={img13}
        imageAlt="Cryptocurrency Token Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is Cryptocurrency Token Development?"
        image={img14}
        paragraphs={[
          "Cryptocurrency token development is the process of creating blockchain-based digital assets that represent value, utility, governance rights, or access within an ecosystem. Unlike native cryptocurrencies, tokens are built on existing blockchain networks and follow predefined smart contract standards, allowing seamless integration with wallets, exchanges, and decentralized applications.",
          "Tokens play a foundational role in modern Web3 ecosystems by enabling decentralized finance, NFT marketplaces, gaming economies, DAO governance, and enterprise automation. A well-designed token not only powers transactions but also aligns incentives between users, investors, and platform operators.",
        ]}
      />

      

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our Cryptocurrency Token Development Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Create Your Own Token for Business Growth"
        image={img13}
        paragraphs={[
          "Creating your own token opens new opportunities for fundraising, customer engagement, and decentralized ownership. Businesses can tokenize assets, reward user participation, enable voting mechanisms, or create in-platform economies that operate transparently on the blockchain.",
          "With customizable token supply models, minting controls, and governance logic, organizations can build sustainable ecosystems that scale globally. Whether launching a startup token, enterprise utility token, or governance asset, tokenization offers unmatched flexibility and innovation potential.",
        ]}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit
        title="Benefits of Cryptocurrency Token Development"
        benefits={benefits}
      />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of Our Token Solutions"
        subtitle="Secure, scalable, and customizable token infrastructure."
        features={[
          {
            icon: sIcon1,
            title: "Custom Tokenomics",
            description:
              "Flexible supply models including fixed, inflationary, and deflationary tokens.",
          },
          {
            icon: sIcon2,
            title: "Smart Contract Automation",
            description:
              "Automated minting, burning, vesting, and governance execution.",
          },
          {
            icon: sIcon3,
            title: "Multi-Chain Deployment",
            description:
              "Deploy tokens across Ethereum, BSC, Polygon, Solana, and more.",
          },
          {
            icon: sIcon4,
            title: "Wallet & Exchange Ready",
            description:
              "Compatible with popular wallets and centralized or decentralized exchanges.",
          },
          {
            icon: sIcon5,
            title: "Security & Audits",
            description:
              "Audited smart contracts to prevent vulnerabilities and exploits.",
          },
          {
            icon: sIcon6,
            title: "Future Scalability",
            description:
              "Upgradeable architecture designed for long-term ecosystem growth.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Expert Blockchain Engineers",
          "Secure & Audited Smart Contracts",
          "End-to-End Token Launch Support",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
